import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 引入子路由
import BID_TRADE_ROUTE from '@/router/business/supplier/participate/bid-trade'
import INQUIRY_TRADE_ROUTE from '@/router/business/supplier/participate/inquiry-trade'
import COMPETE_TRADE_ROUTE from '@/router/business/supplier/participate/compete-trade'
import RECRUIT_TRADE_ROUTE from '@/router/business/supplier/participate/recruit-trade'
import DEMAND_TRADE_ROUTE from '@/router/business/supplier/participate/demand-trade'
import NEGOTIATION_TRADE_ROUTE from '@/router/business/supplier/participate/negotiation-trade'

/**
 * 已参与项目
 */
export default {
  path: 'participate',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '已参与项目',
    icon: 'icon-side_supplier_involved',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 招标采购
    BID_TRADE_ROUTE,
    // 询比采购
    INQUIRY_TRADE_ROUTE,
    // 竞价采购
    COMPETE_TRADE_ROUTE,
    // 谈判采购
    NEGOTIATION_TRADE_ROUTE,
    // 招募
    RECRUIT_TRADE_ROUTE,
    // 需求调查
    DEMAND_TRADE_ROUTE
  ]
}
